const ENTITY = 'TaskSchedulerConfiguration';
const ENTITIES = `${ENTITY}s`;

class HandlerToTaskSchedulerConfigurationForm {
  constructor(
    taskSchedulerRuleTypeField,
    inconstantFields,
    taskSchedulerTitle,
    taskSchedulerDescription,
    organizationField,
    assignedUsersField,
    userRestrictsField,
    schedulerActionType,
    fieldsToggledByScheduleActionType
  ) {
    this.taskSchedulerRuleTypeField = taskSchedulerRuleTypeField;
    this.inconstantFields = inconstantFields;
    this.taskSchedulerTitle = taskSchedulerTitle;
    this.taskSchedulerDescription = taskSchedulerDescription;
    this.organizationField = organizationField;
    this.assignedUsersField = assignedUsersField;
    this.userRestrictsField = userRestrictsField;
    this.schedulerActionType = schedulerActionType;
    this.fieldsToggledByScheduleActionType = fieldsToggledByScheduleActionType;
    this.formModal = null;
    this.oldValue = "";
    this.newValue = "";
    this.attributes = [];
    this.blocks = [];
  }

  eventHandlerToTaskSchedulerRuleTypeField = (event) => {
    this.newValue = event.target.value;
    this.taskSchedulerRuleTypeField.setValue(this.oldValue);
    if (this.schedulerFieldsAreEmpty()) {
      this.taskSchedulerRuleTypeField.setValue(this.newValue);
      this.onChangeShowingFields(this.newValue);
    } else {
      const confirmCallback = this.onHandleClickOnModalChangeButton;

      this.handleModal(confirmCallback);
    }
  };

  handleModal = (confirmAction) => {
    const selector = "#TaskSchedulerConfiguration";
    const options = {
      width: 600,
      height: 180
    }
    this.formModal = new Monet.Form.Modal(selector, options);
    this.formModal.showModalForm();

    const modalContent = document.createElement("div");
    modalContent.className = "content";

    const divTexts = document.createElement("div");

    const popupTitle = document.createElement("h1");
    popupTitle.className = "popupTitle";
    const popupTitleTextNode = document.createTextNode(Monet.I18n.getResourcesByKey('TaskScheduler.changeModal.title'));
    popupTitle.appendChild(popupTitleTextNode);

    const popupMessage = document.createElement("p");
    const alertMessage = Monet.I18n.getResourcesByKey('TaskScheduler.changeModal.message');
    const askMessage = Monet.I18n.getResourcesByKey('TaskScheduler.changeModal.askMessage');
    const popupMessageTextNode = document.createTextNode(`${alertMessage} ${askMessage}`);
    popupMessage.appendChild(popupMessageTextNode);

    divTexts.appendChild(popupTitle);
    divTexts.appendChild(popupMessage);

    const divButtons = document.createElement("div");
    divButtons.className = "buttons standard-form-buttons";
    const btnChange = document.createElement("input");
    btnChange.type = "button";
    btnChange.className = "change";
    btnChange.value = Monet.I18n.getResourcesByKey('TaskScheduler.changeModal.button.change');
    const btnDontChange = document.createElement("input");
    btnDontChange.type = "button";
    btnDontChange.className = "dontChange";
    btnDontChange.value = Monet.I18n.getResourcesByKey('TaskScheduler.changeModal.button.dontChange');
    divButtons.appendChild(btnDontChange);
    divButtons.appendChild(btnChange);

    btnChange.addEventListener('click', confirmAction);
    btnDontChange.addEventListener('click', this.onHandleClickOnModalDontChangeButton);

    modalContent.appendChild(divTexts);
    modalContent.appendChild(divButtons);

    const modal = document.querySelector(selector).querySelector(".popupFormContainer");
    modal.appendChild(modalContent);
  };

  onHandleClickOnModalChangeButton = () => {
    this.taskSchedulerRuleTypeField.setValue(this.newValue);
    this.onChangeShowingFields(this.newValue);
    this.formModal.closeModalWindow();
  };

  onHandleClickOnModalDontChangeButton = () => {
    this.formModal.closeModalWindow();
  };

  onShowFields = () => {
    const value = this.taskSchedulerRuleTypeField.getValue();

    this.blocks = [];
    switch (value) {
      case 'DAMAGED_PRODUCTS_AUDIT':
        this.renderDamagedProductsAuditForm();
        break;
      case 'PROMOTIONAL_PRODUCTS_AUDIT':
        this.renderPromotionalProductsAuditForm();
        break;
      case 'LOW_CUSTOMER_SERVICE_RATING':
        this.renderLowCustomerServiceRatingForm();
        break;
      case 'ROUTE_AVERAGE_SERVICE_RATING':
        this.renderRoutesAverageServiceRatingForm();
        break;
      case 'CREDIT_MANAGEMENT':
        this.renderCreditManagementForm();
        break;
      case 'CANCELED_DELIVERIES':
        this.renderCanceledDeliveriesForm();
        break;
      case 'REDELIVERED_STOPS':
        this.renderRedeliveredStopsForm();
        break;
      case 'SIZES_DELIVERED_ON_SITE':
        this.renderSizesDeliveredOnSiteForm();
        break;
      case 'CLOSED_TASKS':
        this.renderClosedTasksForm();
        break;
      case 'DRIVER_SCORING':
        this.renderDriverScoringForm();
        break;
      case 'LOAN_MANAGEMENT':
        this.renderLoanManagementForm();
        break;
      case 'EVENTS':
        this.renderEventsForm();
        break;
      case 'COMPLETED_ROUTES':
        this.renderCompletedRoutesForm();
        break;
      case 'NOT_COMPLETED_ROUTES':
        this.renderNotCompletedRoutesForm();
        break;
      case 'SERVICED_STOPS':
        this.renderServicedStopsForm();
        break;
      case 'ASSIGNMENT_RESOLUTION':
        this.renderAssignmentResolutionForm();
        break;
    }

    this.renderAddAttributeButtonInTitle();
    this.renderDescription();
  };

  onChangeShowingFields = (value) => {
    const { 
      schedulerAction: { taskTypes } ,
      scheduleTaskCreation: { taskType }
    } = this.fieldsToggledByScheduleActionType;

    this.oldValue = value;
    this.hideInconstantFields();
    this.taskSchedulerTitle.clear();
    this.taskSchedulerDescription.clear();
    taskTypes.clear();
    taskType.clear();

    if (value === "") {
      this.taskSchedulerRuleTypeField.clear();
      return;
    }

    this.onShowFields();
  };

  renderDamagedProductsAuditForm = () => {
    const { isAllDamaged, hasDamagedSize } = this.inconstantFields;
    isAllDamaged.show();
    hasDamagedSize.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.Orders.ordernumber',
        value: 'Orders.orderNumber'
      },
      {
        label: 'SelectKeyResource.SKU.key',
        value: 'SKU.key'
      },
      {
        label: 'SelectKeyResource.SKU.description',
        value: 'SKU.description'
      },
      {
        label: 'SelectKeyResource.Paymentmethod.key',
        value: 'Paymentmethod.key'
      },
      {
        label: 'SelectKeyResource.Paymentmethod.description',
        value: 'Paymentmethod.description'
      },
    ];
  };

  renderPromotionalProductsAuditForm = () => {
    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.Orders.ordernumber',
        value: 'Orders.orderNumber'
      },
      {
        label: 'SelectKeyResource.SKU.key',
        value: 'SKU.key'
      },
      {
        label: 'SelectKeyResource.SKU.description',
        value: 'SKU.description'
      },
      {
        label: 'SelectKeyResource.Lineitem.bonuskey',
        value: 'LineItem.bonusKey'
      },
    ];
  };

  renderLowCustomerServiceRatingForm = () => {
    const { TSConfigDriversRatingScore } = this.inconstantFields;
    TSConfigDriversRatingScore.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.Stopsignature.creationdate',
        value: 'StopSignature.creationDate'
      },
      {
        label: 'SelectKeyResource.Stopsignature.rating',
        value: 'StopSignature.rating'
      },
    ];
  };

  renderRoutesAverageServiceRatingForm = () => {
    const { TSConfigDriversRatingScore } = this.inconstantFields;
    TSConfigDriversRatingScore.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.averageRating',
        value: 'AttributesTaskDescription.averageRating'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.costumersLowRating',
        value: 'AttributesTaskDescription.costumersLowerRating'
      },
    ];
  };

  renderCreditManagementForm = () => {
    const {
      TSConfigDaysOverdue,
      TSConfigWithADebt,
    } = this.inconstantFields;
    TSConfigDaysOverdue.show();
    TSConfigWithADebt.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.balanceDue',
        value: 'AttributesTaskDescription.routeLocationPendingCalculate'
      },
    ];
  };

  renderCanceledDeliveriesForm = () => {
    const {
      TSConfigNumberCanceledStops,
      TSConfigCancelReasons,
    } = this.inconstantFields;
    TSConfigNumberCanceledStops.show();
    TSConfigCancelReasons.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'AttributesTaskDescription.routeKey'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'AttributesTaskDescription.routeDate'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'AttributesTaskDescription.organizationKey'
      },
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.Stop.actualCancel',
        value: 'AttributesTaskDescription.actualCancel'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.size1AliasConfigKey',
        value: 'AttributesTaskDescription.size1AliasConfigKey'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.plannedCanceled',
        value: 'AttributesTaskDescription.plannedCanceled'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.customersTotalCancellation',
        value: 'AttributesTaskDescription.customersCancellation'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.customersCancellation',
        value: 'AttributesTaskDescription.customerCancellationsInRoute'
      },
      {
        label: 'SelectKeyResource.SKU.description',
        value: 'SKU.description'
      }
    ];

    this.blocks = [
      {
        label: 'SelectKeyResource.block.head',
        value: 'Head'
      },
      {
        label: 'SelectKeyResource.block.body',
        value: 'Body'
      },
      {
        label: 'SelectKeyResource.block.skus',
        value: 'Skus'
      },
    ];
  };

  renderRedeliveredStopsForm = () => {
    const {
      TSConfigNumberRedeliveredStops,
      TSConfigRedeliveryReasons,
    } = this.inconstantFields;
    TSConfigNumberRedeliveredStops.show();
    TSConfigRedeliveryReasons.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'AttributesTaskDescription.routeKey'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'AttributesTaskDescription.routeDate'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'AttributesTaskDescription.organizationKey'
      },
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.actualRedelivery',
        value: 'AttributesTaskDescription.actualDeparture'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.totalRedeliveries',
        value: 'AttributesTaskDescription.customersRedelivery'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.redeliveries',
        value: 'AttributesTaskDescription.customerRedeliveryInRoute'
      },
    ];

    this.blocks = [
      {
        label: 'SelectKeyResource.block.head',
        value: 'Head'
      },
      {
        label: 'SelectKeyResource.block.body',
        value: 'Body'
      }
    ];
  };

  renderSizesDeliveredOnSiteForm = () => {
    const {
      TSConfigConformityParameter,
      TSConfigPercentageIndicator,
    } = this.inconstantFields;
    TSConfigConformityParameter.show();
    TSConfigPercentageIndicator.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.geoEffectivenessPercent',
        value: 'AttributesTaskDescription.geoEffectivenessPercent'
      },
    ];
  };

  renderClosedTasksForm = () => {
    const {
      TSConfigPercentageIndicator,
    } = this.inconstantFields;
    TSConfigPercentageIndicator.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.percentNonClosedTasks',
        value: 'AttributesTaskDescription.percentNonClosedTasks'
      },
    ];
  };

  renderDriverScoringForm = () => {
    const {
      TSConfigPercentageIndicator,
    } = this.inconstantFields;
    TSConfigPercentageIndicator.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.percentIndicator',
        value: 'AttributesTaskDescription.scoring'
      },
    ];
  };

  renderLoanManagementForm = () => {
    const {
      TSConfigDaysOverdue,
      TSConfigBalance,
    } = this.inconstantFields;
    TSConfigDaysOverdue.show();
    TSConfigBalance.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Location.key',
        value: 'Location.key'
      },
      {
        label: 'SelectKeyResource.Location.description',
        value: 'Location.description'
      },
      {
        label: 'SelectKeyResource.balanceDue',
        value: 'AttributesTaskDescription.routeConsignedCalculate'
      },
    ];
  };

  renderEventsForm = () => {
    const { TSConfigEvent } = this.inconstantFields;
    TSConfigEvent.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.numberEvents',
        value: 'AttributesTaskDescription.numberEvents'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.idleSpeedMinutes',
        value: 'AttributesTaskDescription.idleSpeedMinutes'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.plannedSize1',
        value: 'AttributesTaskDescription.plannedSize1'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.plannedSize2',
        value: 'AttributesTaskDescription.plannedSize2'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.plannedSize3',
        value: 'AttributesTaskDescription.plannedSize3'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.actualSize1',
        value: 'AttributesTaskDescription.actualSize1'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.actualSize2',
        value: 'AttributesTaskDescription.actualSize2'
      },
      {
        label: 'SelectKeyResource.AttributesTaskDescription.actualSize3',
        value: 'AttributesTaskDescription.actualSize3'
      },
    ];
  };

  renderCompletedRoutesForm = () => {
    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
    ];
  };

  renderNotCompletedRoutesForm = () => {
    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
    ];
  };

  renderServicedStopsForm = () => {
    const {
      TSConfigPercentageIndicator,
    } = this.inconstantFields;
    TSConfigPercentageIndicator.show();

    this.attributes = [
      {
        label: 'SelectKeyResource.Route.key',
        value: 'Route.key'
      },
      {
        label: 'SelectKeyResource.Route.routedate',
        value: 'Route.date'
      },
      {
        label: 'SelectKeyResource.Organization.key',
        value: 'Organization.key'
      },
      {
        label: 'SelectKeyResource.percentServicedStops',
        value: 'AttributesTaskDescription.percentServicedStops'
      },
    ];
  };

  renderAssignmentResolutionForm = () => {
    const {
      unassignedTasks,
      taskTypes
    } = this.inconstantFields;

    unassignedTasks.show();
    taskTypes.show();
  };

  hideInconstantFields = () => {
    Object.keys(this.inconstantFields).forEach((key) => {
      const field = this.inconstantFields[key];
      field.hide();
      field.clear();
      field.rootEl.classList.remove("error");
    });

    let addAttributeButton = this.taskSchedulerTitle.rootEl.querySelector('input.addAttributeBtn');
    addAttributeButton && this.taskSchedulerTitle.rootEl.removeChild(addAttributeButton.parentElement);
  };

  schedulerFieldsAreEmpty = () => {
    if (this.taskSchedulerRuleTypeField.getValue() === "") return true;
    const descriptionValueEncoded = this.taskSchedulerDescription.getValue();
    const descriptionValueDecoded = decodeURI(descriptionValueEncoded);
    const descriptionValue = descriptionValueDecoded.replace(/(<([^>]+)>)/ig,"");
    if (descriptionValue.replace(/\s/g, '').length) return false;
    for (let key in this.inconstantFields) {
      const field = this.inconstantFields[key];
      if (!field.isEmpty()) return false;
    }
    return true;
  }

  schedulerActionTypesFieldsAreEmpty = () => {
    const { 
      schedulerAction: { taskTypes } ,
      scheduleTaskCreation: { taskType }
    } = this.fieldsToggledByScheduleActionType;

    if (taskTypes.getValue().length > 0 || !!taskType.getValue()) {
      return false;
    }

    return true;
  };

  addEventListenerToTaskSchedulerRuleTypeField = () => {
    this.taskSchedulerRuleTypeField.input.addEventListener('change', this.eventHandlerToTaskSchedulerRuleTypeField);
  };

  loadAssignedUsersByOrganization = () => {
    const organizationIsEmpty = this.organizationField.isEmpty();
    if (organizationIsEmpty) {
      this.assignedUsersField.setCustomExecuteFilter(() => {
        const dataProvider = App.Forms[this.assignedUsersField.nameSpace].dataProvider;
        dataProvider.beginUpdate();
        dataProvider.setData([]);
        dataProvider.endUpdate();
        Monet.Grid.Utils.showGridNoResult(this.assignedUsersField.nameSpace);
      });
    } else {
      Monet.Grid.Utils.hideGridNoResult(this.assignedUsersField.nameSpace);
      this.assignedUsersField.setCustomExecuteFilter(null);
    }
    this.assignedUsersField.hideContainer();
  }

  eventHandlerToOrganizationField = (clearAssignedUsersLookup) => {
    if (clearAssignedUsersLookup) {
      this.assignedUsersField.clear();
    }
    this.loadAssignedUsersByOrganization();
  }

  eventHandlerForChangingOrganization = () => {
    const organizationValue = this.organizationField.getValue();
    let clearAssignedUsersLookup = false;
    if (organizationValue && organizationValue.id) {
      clearAssignedUsersLookup = organizationValue.id !== this.previousOrganizationId;
      this.previousOrganizationId = organizationValue.id;
    }
    this.eventHandlerToOrganizationField(clearAssignedUsersLookup);
  }

  addEventListenerToTaskOrganizationField = () => {
    this.organizationField.input.addEventListener('input', this.eventHandlerToOrganizationField);
    this.organizationField.input.addEventListener('blur', this.eventHandlerToOrganizationField);
    this.organizationField.addListenerToAfterSelectRow(this.eventHandlerForChangingOrganization);
  };

  renderDescription = () => {
    this.taskSchedulerDescription.setAttributes(this.attributes);
    this.blocks.length && this.taskSchedulerDescription.setBlocks(this.blocks);
  };

  renderAddAttributeButtonInTitle = () => {
    let addAttributeButton = this.taskSchedulerTitle.rootEl.querySelector('input.addAttributeBtn');
    if (!addAttributeButton) {
      const addAttributeContainer = document.createElement('div');
      const isLocationAttribute = this.attributes.find(attribute => attribute.value === 'Location.key');
      const attributeToAppend = isLocationAttribute ? '@Location.key@' : '@Route.key@';

      addAttributeButton = document.createElement('input');
      addAttributeButton.classList.add('MonetUIButton', 'btn', 'addAttributeBtn', 'tooltip-hover-element');
      addAttributeButton.type = 'button';
      addAttributeButton.value = Monet.I18n.getResourcesByKey('event.button.add.bubble');

      addAttributeButton.addEventListener('click', () => {
        const actualTitle = this.taskSchedulerTitle.getValue();

        if (!actualTitle.includes(attributeToAppend)) {
          const newTitle = `${actualTitle} ${attributeToAppend}`;
          this.taskSchedulerTitle.setValue(newTitle);
        }
      });

      addAttributeContainer.appendChild(addAttributeButton);

      const tooltipElement = document.createElement('span');
      tooltipElement.classList.add('gm-tooltiptext', 'gm-tooltip-right');
      tooltipElement.innerHTML = Monet.I18n.getResourcesByKey('TaskScheduler.title.addAttribute.tooltip', attributeToAppend);

      addAttributeContainer.classList.add('gm-tooltip');
      addAttributeContainer.appendChild(tooltipElement);

      this.taskSchedulerTitle.rootEl.appendChild(addAttributeContainer);
    }
  }

  formatLayoutUserRestrictsField() {
    const options = this.userRestrictsField.rootEl.querySelectorAll('.radio_group_item');
    const optionsWrapper =  document.createElement('div');

    optionsWrapper.classList.add('optionsWrapper');
    optionsWrapper.classList.add('radio_group_item')

    options.forEach((option) => optionsWrapper.appendChild(option));

    this.userRestrictsField.rootEl.appendChild(optionsWrapper);
  }

  formatLayoutSchedulerActionType() {
    const options = this.schedulerActionType.rootEl.querySelectorAll('.radio_group_item');
    const optionsWrapper =  document.createElement('div');

    optionsWrapper.classList.add('optionsWrapper');
    optionsWrapper.classList.add('radio_group_item')

    options.forEach((option) => optionsWrapper.appendChild(option));

    this.schedulerActionType.rootEl.appendChild(optionsWrapper);
    this.schedulerActionType.rootEl.querySelector('.optionGroup-label').innerHTML = '';
  }

  showScheduleActionTypeDependFields(typeToShow, typeToHide) {
    const fieldsToShow = this.fieldsToggledByScheduleActionType[typeToShow] || {};
    const fieldsToHide = this.fieldsToggledByScheduleActionType[typeToHide] || {};

    Object.values(fieldsToShow).forEach(field => {
      field.show();
      field.setMandatory(true);
    });

    Object.values(fieldsToHide).forEach(field => {
      field.hide();
      field.clear();
      field.setMandatory(false);
      field.rootEl.classList.remove("error");
    });
  }

  toggleFieldsByScheduleActionType(type) {
    const SCHEDULER_ACTION = 1;
    const TASK_CREATION = 0;

    const ASSIGNMENT_RESOLUTION_TYPE = 'ASSIGNMENT_RESOLUTION';
    const optionElementSelector = 
      `#TaskSchedulerConfiguration_TSConfigRuleType > select > option[value="${ASSIGNMENT_RESOLUTION_TYPE}"]`;
    const assignmentResolutionRuleType = document.querySelector(optionElementSelector);
    const ruleTypeValue = this.taskSchedulerRuleTypeField.getValue();

    if (type == SCHEDULER_ACTION) {
      const typeToShow = ruleTypeValue === ASSIGNMENT_RESOLUTION_TYPE ? 'schedulerAction' : '';
      const typeToHide = 'scheduleTaskCreation';

      this.showScheduleActionTypeDependFields(typeToShow, typeToHide);
      this.schedulerActionType.setValue(SCHEDULER_ACTION.toString());

      assignmentResolutionRuleType.style.display = 'block';

    } else {
      const typeToShow = 'scheduleTaskCreation';
      const typeToHide = ruleTypeValue === ASSIGNMENT_RESOLUTION_TYPE ? 'schedulerAction' : '';

      this.showScheduleActionTypeDependFields(typeToShow, typeToHide);
      this.schedulerActionType.setValue(TASK_CREATION.toString());

      this.taskSchedulerRuleTypeField.clear();
      assignmentResolutionRuleType.style.display = 'none';
    }
  }

  addEventListenerInSchedulerActionType() {
    this.schedulerActionType.rootEl.querySelectorAll('[name^="RadioItem_"]').forEach(element => {
      const clojureFunction = (e) => {
        const fieldsAreEmpty = this.schedulerActionTypesFieldsAreEmpty();

        if (fieldsAreEmpty) {
          this.toggleFieldsByScheduleActionType(e.target.value);
        } else {
          const confirmCallback = () => {
            this.onChangeShowingFields(this.newValue);
            this.formModal.closeModalWindow();
            this.toggleFieldsByScheduleActionType(e.target.value);
          };

          this.handleModal(confirmCallback);
        }
      };

      element.removeEventListener('change', clojureFunction);
      element.addEventListener('change', clojureFunction);
    });
  }


  init = () => {
    this.hideInconstantFields();
    this.eventHandlerToOrganizationField();
    this.addEventListenerToTaskOrganizationField();
    this.addEventListenerToTaskSchedulerRuleTypeField();
    this.formatLayoutUserRestrictsField();
    this.formatLayoutSchedulerActionType();
    this.addEventListenerInSchedulerActionType();
    this.toggleFieldsByScheduleActionType(this.schedulerActionType.value);
  };
}

class AdjustRequestFormFields {
  fields = null;
  schedulerActionEnum = {
    'SCHEDULE_TASK_CREATION': 0
  };

  setFields = (fields) => {
    this.fields = fields;
    this.schedulerActionTypeValue = fields.schedulerActionType.getValue();
    this.schedulerActionTypeValueAsString = this.schedulerActionTypeValue == 
      this.schedulerActionEnum.SCHEDULE_TASK_CREATION ? 'TASK_CREATION' : 'ACTION';
    this.isFromScheduleActionCreation = this.schedulerActionTypeValue == 
      this.schedulerActionEnum.SCHEDULE_TASK_CREATION;
  }

  getJsonParameters = () => {
    const {
      TSConfigRuleType,
      TSConfigCheckRoutesFrom,
      TSConfigNumberCanceledStops,
      TSConfigCancelReasons,
      TSConfigRedeliveryReasons,
      TSConfigDriversRatingScore,
      TSConfigNumberRedeliveredStops,
      TSConfigDaysOverdue,
      TSConfigBalance,
      TSConfigWithADebt,
      TSConfigPercentageIndicator,
      TSConfigConformityParameter,
      TSConfigEvent,
      hasDamagedSize,
      isAllDamaged,
      unassignedTasks,
      taskType,
      taskTypes
    } = this.fields;

    
    let parameters = {
      'numberDays': TSConfigCheckRoutesFrom.getValue()
    };

    this.isFromScheduleActionCreation && Object.assign(parameters, {
      taskType: taskType.getValue()
    });

    const rule = TSConfigRuleType.getValue();

    switch (rule) {
      case 'DAMAGED_PRODUCTS_AUDIT':
        parameters.hasDamagedSize = hasDamagedSize.getValue();
        parameters.isAllDamaged = isAllDamaged.getValue();
        break;
      case 'LOW_CUSTOMER_SERVICE_RATING':
        parameters.rating = TSConfigDriversRatingScore.getInputValue();
        parameters.operator = TSConfigDriversRatingScore.getComparationSelectValue();
        break;
      case 'ROUTE_AVERAGE_SERVICE_RATING':
        parameters.averageRating = TSConfigDriversRatingScore.getInputValue();
        parameters.operator = TSConfigDriversRatingScore.getComparationSelectValue();
        break;
      case 'CREDIT_MANAGEMENT':
        parameters.numberOfDaysOverdue = TSConfigDaysOverdue.getInputValue();
        parameters.operatorNumberOfDaysOverdue = TSConfigDaysOverdue.getComparationSelectValue();
        parameters.balance = TSConfigWithADebt.getInputValue();
        parameters.operatorBalance = TSConfigWithADebt.getComparationSelectValue();
        break;
      case 'CANCELED_DELIVERIES':
        parameters.numberOfCancellation = TSConfigNumberCanceledStops.getInputValue();
        parameters.operator = TSConfigNumberCanceledStops.getComparationSelectValue();
        parameters.cancelCodes = TSConfigCancelReasons.getValue();
        break;
      case 'REDELIVERED_STOPS':
        parameters.numberOfRedelivery = TSConfigNumberRedeliveredStops.getInputValue();
        parameters.operator = TSConfigNumberRedeliveredStops.getComparationSelectValue();
        parameters.undeliverableCodes = TSConfigRedeliveryReasons.getValue();
        break;
      case 'SIZES_DELIVERED_ON_SITE':
        parameters.percentIndicator = TSConfigPercentageIndicator.getInputValue();
        parameters.operator = TSConfigPercentageIndicator.getComparationSelectValue();
        parameters.geoEffectivenessType = TSConfigConformityParameter.getValue();
        break;
      case 'CLOSED_TASKS':
        parameters.percentIndicator = TSConfigPercentageIndicator.getInputValue();
        parameters.operator = TSConfigPercentageIndicator.getComparationSelectValue();
        break;
      case 'DRIVER_SCORING':
        parameters.percentIndicator = TSConfigPercentageIndicator.getInputValue();
        parameters.operator = TSConfigPercentageIndicator.getComparationSelectValue();
        break;
      case 'LOAN_MANAGEMENT':
        parameters.numberOfDaysOverdue = TSConfigDaysOverdue.getInputValue();
        parameters.operatorNumberOfDaysOverdue = TSConfigDaysOverdue.getComparationSelectValue();
        parameters.debt = TSConfigBalance.getInputValue();
        parameters.operatorDebt = TSConfigBalance.getComparationSelectValue();
        break;
      case 'EVENTS':
        const eventId = TSConfigEvent.getValue().id;
        parameters.eventIds = [eventId];
        break;
      case 'SERVICED_STOPS':
        parameters.percentIndicator = TSConfigPercentageIndicator.getInputValue();
        parameters.operator = TSConfigPercentageIndicator.getComparationSelectValue();
        break;
      case 'ASSIGNMENT_RESOLUTION':
        parameters.onlyUnassigned = unassignedTasks.getValue();
        parameters.taskTypes = taskTypes.getValue();

        break;
    }

    return JSON.stringify(parameters);
  };

  getUserGroups = () => {
    const {
      assignedGroups,
      assignedUsers,
    } = this.fields;

    const taskSchedulerUserGroups = [];
    const savedTaskSchedulerUserGroups = App.Forms[ENTITY].taskSchedulerUserGroups;

    assignedGroups.getValue().forEach(item => {
      const assignedGroup = {
        assignedGroup: {
          id: item.id
        }
      };

      if(savedTaskSchedulerUserGroups) {
        const savedAssignedGroup = savedTaskSchedulerUserGroups.filter(object => object.assignedGroup && (object.assignedGroup.id === item.id));
        if(savedAssignedGroup && savedAssignedGroup.length) {
          assignedGroup.id = savedAssignedGroup[0].id;
        }
      }

      taskSchedulerUserGroups.push(assignedGroup);
    });

    assignedUsers.getValue().forEach(item => {
      const assignedUser = {
        assignedUser: {
          id: item.id
        }
      };

      if(savedTaskSchedulerUserGroups) {
        const savedAssignedUser = savedTaskSchedulerUserGroups.filter(object => object.assignedUser && (object.assignedUser.id === item.id));
        if (savedAssignedUser && savedAssignedUser.length) {
          assignedUser.id = savedAssignedUser[0].id;
        }
      }
      taskSchedulerUserGroups.push(assignedUser);
    });
    return taskSchedulerUserGroups;
  };

  getSurveys = () => {
    const { taskSchedulerSurveys } = this.fields;
    const taskSchedulerSurveysAdapted = taskSchedulerSurveys.getValue().map(item => {
      return { survey: { id: item.id } };
    });
    return taskSchedulerSurveysAdapted;
  };

  getBodyData = () => {
    const {
      TSConfigRuleType,
      TSConfigTaskTitle,
      TSConfigDescription,
      cron,
      numberDaysUntil,
      maximumNumberOfTasks,
      organization,
      taskType,
      enabled,
      key,
      userRestricts
    } = this.fields;

    const jsonBody = {
      cron: cron.getValue(),
      taskScheduler: {
        organization: organization.getValue(),
        enabled: enabled.getValue(),
        key: key.getValue(),
        userRestricts: userRestricts.getValue(),
        taskSchedulerUserGroups: this.getUserGroups(),
        taskSchedulerRule: {
          type: TSConfigRuleType.getValue(),
          jsonParameters: this.getJsonParameters(),
        },
        taskSchedulerSurveys: this.getSurveys(),
        scheduleAction: this.schedulerActionTypeValueAsString
      },
    };

    this.isFromScheduleActionCreation && Object.assign(jsonBody.taskScheduler.taskSchedulerRule, {
      taskType: taskType.getValue(),
      taskTitle: TSConfigTaskTitle.getValue(),
      taskDescription: TSConfigDescription.getValue(),
      quantity: maximumNumberOfTasks.getValue(),
      due: numberDaysUntil.getValue(),
    });

    return jsonBody;
  }

  getExportFormatsFields = (fieldList) => {
    fieldList.forEach(field => {
      switch(field.name) {
        case 'TSConfigTaskTitle':
          field.formattedName = "taskSchedulerRule.taskTitle";
          break;
        case 'assignedGroups':
          field.formattedName = "taskSchedulerUserGroups.assignedGroup";
          break;
        case 'assignedUsers':
          field.formattedName = "taskSchedulerUserGroups.assignedUser";
          break;
        case 'TSConfigDescription':
          field.formattedName = "taskSchedulerRule.taskDescription";
          break;
        case 'TSConfigRuleType':
          field.formattedName = "taskSchedulerRule.type";
          break;
        case 'taskType':
          field.formattedName = "taskSchedulerRule.taskType";
          break;
      }
    });
    return fieldList;
  }
}

class AttributesFormFieldsUtil {

  getRulesAttributes = (taskSchedulerRule) => {
    const formAttributes = {};
    const jsonParameters = JSON.parse(taskSchedulerRule.jsonParameters);
    formAttributes["TSConfigTaskTitle"] = taskSchedulerRule.taskTitle;
    formAttributes["TSConfigDescription"] = taskSchedulerRule.taskDescription;
    formAttributes["TSConfigRuleType"] = taskSchedulerRule.type;
    formAttributes["taskType"] = taskSchedulerRule.taskType;
    formAttributes["numberDaysUntil"] = taskSchedulerRule.due;
    formAttributes["maximumNumberOfTasks"] = taskSchedulerRule.quantity;
    formAttributes["TSConfigCheckRoutesFrom"] = jsonParameters.numberDays || '';
    formAttributes["taskTypes"] = jsonParameters.taskTypes || [];
    formAttributes["unassignedTasks"] = jsonParameters?.onlyUnassigned || false;

    let operator;
    let operatorNumberOfDaysOverdue;
    let operatorDebt;
    let operatorBalance;
    
    switch (taskSchedulerRule.type) {
      case 'DAMAGED_PRODUCTS_AUDIT':
        formAttributes["hasDamagedSize"] = jsonParameters.hasDamagedSize || false;
        formAttributes["isAllDamaged"] = jsonParameters.isAllDamaged || false;
        break;
      case 'PROMOTIONAL_PRODUCTS_AUDIT':
        
        break;
      case 'LOW_CUSTOMER_SERVICE_RATING':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigDriversRatingScore"] = {
          value: jsonParameters.rating,
          operator
        };
        break;
      case 'ROUTE_AVERAGE_SERVICE_RATING':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigDriversRatingScore"] = {
          value: jsonParameters.averageRating,
          operator
        };
        break;
      case 'CREDIT_MANAGEMENT':
        operatorNumberOfDaysOverdue = jsonParameters.operatorNumberOfDaysOverdue.replace(/&lt;/, '<').replace(/&gt;/, '>');
        operatorBalance = jsonParameters.operatorBalance.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigDaysOverdue"] = {
          value: jsonParameters.numberOfDaysOverdue,
          operator: operatorNumberOfDaysOverdue
        };
        formAttributes["TSConfigWithADebt"] = {
          value: jsonParameters.balance,
          operator: operatorBalance
        };
        break;
      case 'CANCELED_DELIVERIES':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigNumberCanceledStops"] = {
          value: jsonParameters.numberOfCancellation,
          operator
        };
        const cancelCodeIds = jsonParameters.cancelCodes.map((item) => item.id);
        formAttributes["TSConfigCancelReasons"] = cancelCodeIds;
        break;
      case 'REDELIVERED_STOPS':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigNumberRedeliveredStops"] = {
          value: jsonParameters.numberOfRedelivery,
          operator
        };
        const undeliverableCodeIds = jsonParameters.undeliverableCodes.map((item) => item.id);
        formAttributes["TSConfigRedeliveryReasons"] = undeliverableCodeIds;
        break;
      case 'SIZES_DELIVERED_ON_SITE':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigPercentageIndicator"] = {
          value: jsonParameters.percentIndicator,
          operator
        };
        formAttributes["TSConfigConformityParameter"] = jsonParameters.geoEffectivenessType;
        break;
      case 'CLOSED_TASKS':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigPercentageIndicator"] = {
          value: jsonParameters.percentIndicator,
          operator
        };
        break;
      case 'DRIVER_SCORING':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigPercentageIndicator"] = {
          value: jsonParameters.percentIndicator,
          operator
        };
        break;
      case 'LOAN_MANAGEMENT':
        operatorNumberOfDaysOverdue = jsonParameters.operatorNumberOfDaysOverdue.replace(/&lt;/, '<').replace(/&gt;/, '>');
        operatorDebt = jsonParameters.operatorDebt.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigDaysOverdue"] = {
          value: jsonParameters.numberOfDaysOverdue,
          operator: operatorNumberOfDaysOverdue
        };
        formAttributes["TSConfigBalance"] = {
          value: jsonParameters.debt,
          operator: operatorDebt
        };
        break;
      case 'EVENTS':
        const eventObj = {
          id: jsonParameters.eventIds[0]
        };
        formAttributes["TSConfigEvent"] = eventObj;
        break;
      case 'SERVICED_STOPS':
        operator = jsonParameters.operator.replace(/&lt;/, '<').replace(/&gt;/, '>');
        formAttributes["TSConfigPercentageIndicator"] = {
          value: jsonParameters.percentIndicator,
          operator
        };
        break;
    }
    return formAttributes;
  }

  parseAttributesToForm = (attributes) => {
    let formAttributes = {};
    Object.keys(attributes).forEach((key) => {
      switch (key) {
        case 'taskSchedulerRule':
          const taskSchedulerRule = attributes[key];
          const ruleAttributes = this.getRulesAttributes(taskSchedulerRule);
          formAttributes = {...formAttributes, ...ruleAttributes};
          break;
        case 'taskSchedulerUserGroups':
          const taskSchedulerUserGroups = attributes[key];
          const assignedGroupsList = [];
          const assignedUsersList = [];
          taskSchedulerUserGroups.forEach(item => {
            if (item.hasOwnProperty('assignedGroup')) {
              assignedGroupsList.push(item.assignedGroup);
            } else if (item.hasOwnProperty('assignedUser')) {
              assignedUsersList.push(item.assignedUser);
            }
          });
          formAttributes["assignedGroups"] = assignedGroupsList;
          formAttributes["assignedUsers"] = assignedUsersList;
          break;
        case 'taskSchedulerSurveys':
          const taskSchedulerSurveys = attributes[key];
          const surveyList = [];
          taskSchedulerSurveys.forEach(item => {
            surveyList.push(item.survey)
          })
          formAttributes["taskSchedulerSurveys"] = surveyList;
          break;
        default:
          formAttributes[key] = attributes[key];
      }
    });
    return formAttributes;
  }
}

/* Model */
class TaskSchedulerConfigurationModel extends App.Models.BaseModel {
  modelUrl = 'TaskSchedulerConfiguration';
}

App.Models[ENTITY] = TaskSchedulerConfigurationModel;


/* Collection */
class TaskSchedulerConfigurationCollection extends App.Collections.BaseCollection {
  url = 'TaskScheduler';
  model = App.Models[ENTITY];
}

App.Collections[ENTITIES] = TaskSchedulerConfigurationCollection;

/* Router */
class TaskSchedulerConfigurationRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = ENTITY;
    const model = App.Models[ENTITY];
    const collectionClass = App.Collections[ENTITIES];

    super(entityName, model, collectionClass);

    // LOCAL VARIABLES
    this.taskSchedulerConfigurationFormHandler = null;
  }

  afterCreateForm = () => {
    const fields = App.Forms[ENTITY].form.fields;

    const {
      TSConfigRuleType,
      TSConfigDaysOverdue,
      TSConfigDriversRatingScore,
      TSConfigWithADebt,
      TSConfigNumberCanceledStops,
      TSConfigNumberRedeliveredStops,
      TSConfigPercentageIndicator,
      TSConfigScore,
      TSConfigBalance,
      TSConfigCancelReasons,
      TSConfigRedeliveryReasons,
      TSConfigConformityParameter,
      TSConfigEvent,
      TSConfigTaskTitle,
      TSConfigDescription,
      organization,
      assignedUsers,
      isAllDamaged,
      hasDamagedSize,
      userRestricts,
      schedulerActionType,
      numberDaysUntil,
      maximumNumberOfTasks,
      taskType,
      taskTypes,
      unassignedTasks
    } = fields;

    const inconstantFields = {
      TSConfigDaysOverdue,
      TSConfigDriversRatingScore,
      TSConfigWithADebt,
      TSConfigNumberCanceledStops,
      TSConfigNumberRedeliveredStops,
      TSConfigPercentageIndicator,
      TSConfigScore,
      TSConfigBalance,
      TSConfigCancelReasons,
      TSConfigRedeliveryReasons,
      TSConfigConformityParameter,
      TSConfigEvent,
      isAllDamaged,
      hasDamagedSize,
      unassignedTasks,
      taskTypes
    };

    const fieldsToggledByScheduleActionType = {
      'scheduleTaskCreation': {
        TSConfigTaskTitle,
        TSConfigDescription,
        numberDaysUntil,
        maximumNumberOfTasks,
        taskType,
      },
      'schedulerAction': {
        unassignedTasks,
        taskTypes
      }
    };

    // Clear before saved data
    App.Forms[ENTITY].taskSchedulerRuleId = null;
    App.Forms[ENTITY].taskSchedulerUserGroups = null;
    App.Forms[ENTITY].taskSchedulerSurveys = null;
    this.taskSchedulerConfigurationFormHandler = new HandlerToTaskSchedulerConfigurationForm(
      TSConfigRuleType,
      inconstantFields,
      TSConfigTaskTitle,
      TSConfigDescription,
      organization,
      assignedUsers,
      userRestricts,
      schedulerActionType,
      fieldsToggledByScheduleActionType
    );
    this.taskSchedulerConfigurationFormHandler.init();
  };

  beforeCreate = (model_to_create) => {
    const fields = App.Forms[ENTITY].form.fields;

    const adjustRequestFormFields = new AdjustRequestFormFields();
    adjustRequestFormFields.setFields(fields);

    model_to_create.url = () => {
      return "TaskScheduler/Create"
    };
    model_to_create.clear();
    model_to_create.set(adjustRequestFormFields.getBodyData());
  };

  beforeUpdate = () => {
    const fields = App.Forms[ENTITY].form.fields;

    const adjustRequestFormFields = new AdjustRequestFormFields();
    adjustRequestFormFields.setFields(fields);

    this.updateModel.url = () => {
      return "TaskScheduler/Update"
    };

    const taskSchedulerId = this.form_edit.id;

    this.form_edit = adjustRequestFormFields.getBodyData();
    this.form_edit.id = taskSchedulerId;
    this.form_edit.taskScheduler.id = taskSchedulerId;
    this.form_edit.taskScheduler.taskSchedulerRule.id = App.Forms[ENTITY].taskSchedulerRuleId;

    this.updateModel.clear();
    this.updateModel.set(this.form_edit);
  };

  beforeSendBatchDeleteRequest = (ajax) => {
    ajax.url = `TaskScheduler/BatchDelete`;
  };

  beforeValidate = (form) => {
    const assignedGroupsField = form.fields.assignedGroups;
    const assignedUsersField = form.fields.assignedUsers;
    assignedGroupsField.validate = () => {
      const errors = [];
      const fieldLabel = assignedGroupsField.label.textContent;
      const isMandatoryAndIsNotFilledAndIsNotHidden = assignedGroupsField.isMandatory() && assignedGroupsField.isEmpty() && !assignedGroupsField.isHidden;
      if (isMandatoryAndIsNotFilledAndIsNotHidden && assignedUsersField.isEmpty()) {
        errors.push(Monet.Form.Messages.mountErrorMessageObject(Monet.I18n.getResourcesByKey('TaskSchedulerConfiguration.mandatoryUserOrGroup')));
      }
      const dataIsInvalid = assignedGroupsField.dataIsInvalid();
      if (dataIsInvalid) {
        errors.push(Monet.Form.Messages.mountErrorMessageObject(`${Monet.I18n.getResourcesByKey(fieldLabel)} ${Monet.I18n.getResourcesByKey(assignedGroupsField.dataInvalidErrorText)}`));
      }
      if ((isMandatoryAndIsNotFilledAndIsNotHidden && assignedUsersField.isEmpty()) || dataIsInvalid) {
        assignedGroupsField.rootEl.className += ' control-group error';
      }
      return errors;
    };
    assignedUsersField.validate = () => {
      const errors = [];
      const fieldLabel = assignedUsersField.label.textContent;
      const isMandatoryAndIsNotFilledAndIsNotHidden = assignedUsersField.isMandatory() && assignedUsersField.isEmpty() && !assignedUsersField.isHidden;
      
      const dataIsInvalid = assignedUsersField.dataIsInvalid();
      if (dataIsInvalid) {
        errors.push(Monet.Form.Messages.mountErrorMessageObject(`${Monet.I18n.getResourcesByKey(fieldLabel)} ${Monet.I18n.getResourcesByKey(assignedUsersField.dataInvalidErrorText)}`));
      }
      if ((isMandatoryAndIsNotFilledAndIsNotHidden && assignedGroupsField.isEmpty()) || dataIsInvalid) {
        assignedUsersField.rootEl.className += ' control-group error';
      }
      return errors;
    };
  };

  beforeInitializeGrid = (form, layout) => {
    layout.sections[0].sectionRelatedLists[0].searchGridLayout.searchGridColumns.forEach((column) => {

       switch (column.field.name) {
          case 'TSConfigTaskTitle':
            column.field.name = 'taskSchedulerRule.taskTitle';
            break;
          case 'TSConfigDescription':
            column.field.name = 'taskSchedulerRule.taskDescription';
            break;
          case 'TSConfigRuleType':
            column.field.name = 'taskSchedulerRule.type';
            break;
          case 'taskType':
            column.field.name = 'taskSchedulerRule.taskType';
            break;
          default:
            break;
        }
    })
  };

  beforeList = () => {
    const filterBuilder = App.Forms[ENTITY].filterBuilder;
    const projection = {
      "filters": [
        "*",
        "id",
        "organization.id",
        "organization.description",
        "taskSchedulerRule.*",
        "taskSchedulerRule.taskType.*"
      ],
    };
    filterBuilder.projection = JSON.stringify(projection);

    filterBuilder.getCriteria = (field, key, isSomebodysFather) => {
      const criteria = {};
      let keySufix = '';
      const fieldsTypeAnyList = ['PICKLIST_MULTISELECT', 'PICKLIST', 'LOOKUP', 'PICKLIST_MULTISELECT_FILTER', 'POWER_LOOKUP_LIST_FILTER'];
      const fieldTypeText = ['TEXT_AREA', 'TEXT', 'EMAIL', 'TEXT_EDITOR_ATTRIBUTES', 'TEXT_AREA_ATTRIBUTES'];
      let value = field.getFilterValue();
      const valueIsArray = (value instanceof Array);
      const fieldName = field.name;

      const taskSchedulerRuleFields = ['taskType', 'TSConfigTaskTitle', 'TSConfigDescription', 'TSConfigRuleType'];
      const taskSchedulerUserGroupsFields = ['assignedGroups', 'assignedUsers'];

      if (taskSchedulerRuleFields.includes(fieldName)) {
        keySufix = 'taskSchedulerRule.';
      } else if (taskSchedulerUserGroupsFields.includes(fieldName)) {
        keySufix = 'taskSchedulerUserGroups.';
      }

      if (filterBuilder.hasFieldValue(value)) {
        let attr = keySufix;
        switch (key) {
          case 'TSConfigTaskTitle':
            attr += 'taskTitle';
            break;
          case 'TSConfigDescription':
            attr += 'taskDescription';
            break;
          case 'TSConfigRuleType':
            attr += 'type';
            break;
          case 'assignedGroups':
            attr += 'assignedGroup';
            break;
          case 'assignedUsers':
            attr += 'assignedUser';
            break;
          default:
            attr += key;
        }
        if (fieldsTypeAnyList.indexOf(filterBuilder.fieldList[key].type) !== -1) {
          if (!(field.dataIsFieldDomain && field.dataIsFieldDomain())) {
            attr += '.id';
          }
        } else {
          if (fieldTypeText.indexOf(filterBuilder.fieldList[key].type) !== -1) {
            criteria.matchMode = filterBuilder.getMatchMode(value);
            value = filterBuilder.removeIdentifierMatchModeOfValue(value);
          }
          if (filterBuilder.fieldList[key].lookupEntityColumn) {
            attr += '.' + filterBuilder.fieldList[key].lookupEntityColumn;
          }
        }
        if (filterBuilder.fieldNameSufix && isSomebodysFather) {
          attr = attr.replace(filterBuilder.fieldNameSufix + '.', '');
        }
        criteria.attr = attr;

        if (valueIsArray) {
          criteria.in = value;
        } else {
          criteria.eq = value;
        }
        return criteria;
      }
      return false;
    };

    const updateGrid = function (collection) {
      var addPaginationGrid = true,
        tableLayout = Monet.Grid.getGridLayout(App.Forms[ENTITY].layout.index),
        pagination = App.Forms[ENTITY].pagination;
      if (pagination.first === 0) {
        Monet.Grid.addDataToGrid(ENTITY, tableLayout, collection, addPaginationGrid);
      } else {
        Monet.Grid.appendDataToGridAfterPagination(ENTITY, tableLayout, collection);
      }
    };

    filterBuilder.setCallbacks({
      success: (data) => {
        const newModels = [];
        const newData = data;

        data.models.forEach(item => {
          const attributesFormFieldsUtil = new AttributesFormFieldsUtil();
          const newAttributes = attributesFormFieldsUtil.parseAttributesToForm(item.attributes);
 
          const TSDescription = newAttributes?.TSConfigDescription;

          newAttributes.TSConfigDescription = TSDescription ? decodeURI(TSDescription).replace(/<(?:.|\n)*?>/gm, '') : ' ';
          newAttributes.taskSchedulerRule = item.attributes.taskSchedulerRule;
          newAttributes.taskSchedulerRule.taskDescription = newAttributes.TSConfigDescription;
          newAttributes.schedulerActionType = newAttributes.scheduleAction;

          item.attributes = newAttributes;

          newModels.push(item);
        });
        newData.models = newModels;
        updateGrid(newData);
      }
    });

    const exportFormats = App.Forms[ENTITY].actions.exportFormats;
    exportFormats.entityToRequest = "TaskScheduler";
    exportFormats.beforeRenderAllFieldsList = (fieldList) => {
      const adjustRequestFormFields = new AdjustRequestFormFields();
      fieldList = adjustRequestFormFields.getExportFormatsFields(fieldList);
    };
  };

  setJSONParametersToFields = (jsonParameters) => {
    const { taskTypes, onlyUnassigned = false } = JSON.parse(jsonParameters);
    const taskSchedulerForm = App.Forms.TaskSchedulerConfiguration.form.fields;

    taskTypes && taskSchedulerForm.taskTypes.setValue(taskTypes)
    taskSchedulerForm.unassignedTasks.setValue(onlyUnassigned);
  };

  beforeRenderDataToForm = (item, callback) => {
    const ajax = new Monet.Ajax();
    ajax.url = `/TaskScheduler/Retrieve/${item.id}`;
    ajax.method = 'GET';

    ajax.success = (response) => {
      const {
        taskSchedulerRule,
        taskSchedulerUserGroups,
        taskSchedulerSurveys,
        scheduleAction
      } = response.taskScheduler;

      App.Forms[ENTITY].taskSchedulerRuleId = taskSchedulerRule.id;
      App.Forms[ENTITY].taskSchedulerUserGroups = taskSchedulerUserGroups;
      App.Forms[ENTITY].taskSchedulerSurveys = taskSchedulerSurveys;

      const attributesFormFieldsUtil = new AttributesFormFieldsUtil();
      const newAttributes = attributesFormFieldsUtil.parseAttributesToForm(item.attributes);
      const jsonParameters = taskSchedulerRule.jsonParameters;
      const selectedAction = scheduleAction === 'ACTION' ? '1' : '0';

      newAttributes["cron"] = response.cron;
      item.attributes = newAttributes;
      
      this.setJSONParametersToFields(jsonParameters);
      this.taskSchedulerConfigurationFormHandler
        .toggleFieldsByScheduleActionType(selectedAction);
      
      callback(item);
    }

    ajax.send();
  };

  afterPopulateForm = () => {
    this.taskSchedulerConfigurationFormHandler.onShowFields();
    this.taskSchedulerConfigurationFormHandler.loadAssignedUsersByOrganization();
  };

  beforePopulateLocalCollection = () => {
    const projection = {
      "filters": [
        "*",
        "id",
        "organization.id",
        "organization.description",
        "taskSchedulerRule.*",
        "taskSchedulerRule.taskType.*",
        "taskSchedulerUserGroups.assignedGroup.*",
        "taskSchedulerUserGroups.assignedUser.*",
        "taskSchedulerSurveys.survey.id",
        "taskSchedulerSurveys.survey.description"
      ]
    };
    this.projection = JSON.stringify(projection);
  };

  /**
   * 
   * This method is called in the changeset (it is defined in the "meta" column), 
   * and it is executed in javascript when `afterCreateFilter` is called
   * 
   */
  changeAssignedUsersCriteria = (lookupElement) => {
    const setOrganizationAndGroupCriteria = (criteria) => {
      const filterByOrganization = criteria.criteriaChain[0].and.some(
        condition => condition.attr === 'organization.id'
      );

      if (!filterByOrganization) {
        const newCriteria = {
          attr: 'organization.id',
          eq: App.Forms[ENTITY].form.fields.organization.getValue().id
        };
        criteria.criteriaChain[0].and.push(newCriteria);
      }

      const groupCriteria = {
        "attr":"groups.key",
        "neq" : "DRIVER"
      };

      const activeCriteria = {
        "attr": "enabled",
        "eq": true
      }
      
      criteria.criteriaChain[0].and.push(groupCriteria);
      criteria.criteriaChain[0].and.push(activeCriteria);

      return criteria;
    };

    lookupElement.filter.changeCriteriaBeforeFilter = setOrganizationAndGroupCriteria;
  };
}

App.Routers[ENTITY] = TaskSchedulerConfigurationRouter;
